    import React, {useState,useEffect} from "react";
import { Link } from "react-router-dom";
import {Link as ScrollLink} from "react-scroll"
import FormModal from "./FormModal";
import AOS from 'aos';
import 'aos/dist/aos.css';
// import { ScrollLink } from "react-scroll";

function Button({ name, design, action, pageLink, url, formID, sourceFile, modalfunction, section_id}) {

    useEffect(() => {
            AOS.init({ duration: 1000 });
        }, []);

    const ScrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        })
    }

        

    function renderContent() {
        switch (action) {
            case 'internal-linking':
                return (
                    <Link to={pageLink}>
                        <button class={`group relative overflow-hidden px-9 py-3 transition-colors duration-500 ${design === "filled" ? "bg-[#F5D000]" : "bg-transparent border-[2px] border-[#F5D000]"}`} onClick={ScrollToTop}>
                            <h3 class={`font-alibaba font-bold text-[17px] text-black relative z-10 transition-colors duration-500 ${design === "filled" ? "group-hover:text-white" : ""}`}>{name}</h3>
                            <span class={`absolute inset-0 origin-left scale-x-0 transform transition-transform duration-500 ease-in group-hover:scale-x-100 ${design === "filled" ? "bg-brown" : "bg-[#F5D000]"}`}></span>
                        </button>
                    </Link>
                );
                
                
            case 'internal-linking-white' :
                return(
                    <Link to = {pageLink}>
                        <button class={`group relative overflow-hidden px-8 py-3 transition-colors duration-500 sm:px-12 sm:py-4 ${design ==="filled"? "bg-[#F5D000]" : "bg-transparent border-[2px] border-[#F5D000]"}`} onClick={ScrollToTop}>
                            <h3 class={`font-alibaba font-bold text-[17px] text-black relative z-10 transition-colors duration-500 ${design === "filled"? "group-hover:text-black" : ""}`}>{name}</h3>
                            <span class={`absolute inset-0 origin-left scale-x-0 transform transition-transform duration-500 ease-in group-hover:scale-x-100 ${design === "filled" ? "bg-white" : "bg-[#F5D000]"}`}></span>
                        </button>  
                    </Link>
                );
                
            case 'external-linking' :
                return(
                    <a href={url} target="_blank">
                        <button class={` group relative overflow-hidden px-9 py-3 transition-colors duration-500 ${design === "filled" ? "bg-[#F5D000]" : "bg-transparent border-[2px] border-[#F5D000]"}`} onClick={ScrollToTop}>
                            <h3 class={`font-alibaba font-bold text-[16px] text-black relative z-10 transition-colors duration-500 ${design === "filled" ? "group-hover:text-white" : ""}`}>{name}</h3>
                            <span class={`absolute inset-0 origin-left scale-x-0 transform transition-transform duration-500 ease-in group-hover:scale-x-100 ${design === "filled" ? "bg-brown" : "bg-[#F5D000]"}`}></span>
                        </button>
                    </a>
                );

            case 'form-submit':
                return (
                    <button class={` group relative overflow-hidden px-9 py-3 transition-colors duration-500 ${design === "filled" ? "bg-[#F5D000]" : "bg-transparent border-[2px] border-[#F5D000]"}`} type="submit" form={formID}>
                        <h3 class={`font-alibaba font-bold text-[16px] text-black relative z-10 transition-colors duration-500 ${design === "filled" ? "group-hover:text-white" : ""}`}>{name}</h3>
                        <span class={`absolute inset-0 origin-left scale-x-0 transform transition-transform duration-500 ease-in group-hover:scale-x-100 ${design === "filled" ? "bg-black" : "bg-[#F5D000]"}`}></span>
                    </button>
                );

            case 'scroll':
                return (
                    <ScrollLink to={section_id} smooth={true} duration={500}>
                        <button class={` group relative overflow-hidden px-9 py-3 transition-colors duration-500 ${design === "filled" ? "bg-[#F5D000]" : "bg-transparent border-[2px] border-[#F5D000]"}`} >
                            <h3 class={`font-alibaba font-bold text-[16px] text-black relative z-10 transition-colors duration-500 ${design === "filled" ? "group-hover:text-white" : ""}`}>{name}</h3>
                            <span class={`absolute inset-0 origin-left scale-x-0 transform transition-transform duration-500 ease-in group-hover:scale-x-100 ${design === "filled" ? "bg-black" : "bg-[#F5D000]"}`}></span>
                        </button>
                    </ScrollLink>
                );
            case 'download' :
                return(
                    <a href={section_id} target="_blank" download>
                        <button class={` group relative overflow-hidden px-9 py-3 transition-colors duration-500 ${design === "filled" ? "bg-[#F5D000]" : "bg-transparent border-[2px] border-[#F5D000]"}`} >
                            <h3 class={`font-alibaba font-bold text-[16px] text-black relative z-10 transition-colors duration-500 ${design === "filled" ? "group-hover:text-white" : ""}`}>{name}</h3>
                            <span class={`absolute inset-0 origin-left scale-x-0 transform transition-transform duration-500 ease-in group-hover:scale-x-100 ${design === "filled" ? "bg-black" : "bg-[#F5D000]"}`}></span>
                        </button>
                    </a>
                );
            
            case 'modal-open' :
                 return(
                    <button class={`group relative overflow-hidden px-9 py-3 transition-colors duration-300 ${design ==="filled"? "bg-[#F5D000]" : "bg-transparent border-[2px] border-[#F5D000]"}`} onClick={modalfunction} >
                        <h3 class={`font-alibaba font-bold font-medium text-[16px] text-black relative z-10 transition-colors duration-300 ${design === "filled"? "group-hover:text-white" : ""}`}>{name}</h3>
                        <span class={`absolute inset-0 origin-left scale-x-0 transform transition-transform duration-300 ease-in group-hover:scale-x-100 ${design === "filled" ? "bg-brown" : "bg-[#F5D000]"}`}></span>
                    </button>  
                );
        }
    }
    return (
        <>
            {renderContent()}
        </>

    )
}


export default Button;




